//#region types
import { AuthEnums } from "models/enums";
//#endregion
import useAPIClientHelper from "./useAPIClientHelper";

export type VismaAdvisorConnectionStatus = "PendingConfirmation" | "Active" | "Paused" | "NeedsReauthorization";

export interface VismaAdvisorStatusResponse {
  isEnrolled?: boolean;
  isConnected?: boolean;
  status?: VismaAdvisorConnectionStatus;
  agencyName?: string;
}

interface VismaAdvisorInitiateResponse {
  authorizeUrl?: string;
}

const vismaAdvisorApiUrl = "api/services/vismaadvisor/connect";

function useVismaAdvisorService() {
  const { apiClientInstance } = useAPIClientHelper();

  // Not generated in wint-api-client; same raw-route pattern as useStripeConnectService.
  const getStatus = () =>
    apiClientInstance(AuthEnums.AuthType.Company, { showErrors: false, timeout: 8000 })
      .get(`${vismaAdvisorApiUrl}/status`)
      .then((res) => res.data as VismaAdvisorStatusResponse);

  const initiate = (returnPath?: string) =>
    apiClientInstance(AuthEnums.AuthType.Company, { showErrors: true })
      .post(`${vismaAdvisorApiUrl}/initiate`, { returnPath })
      .then((res) => res.data as VismaAdvisorInitiateResponse);

  const confirm = () =>
    apiClientInstance(AuthEnums.AuthType.Company, { showErrors: true }).post(`${vismaAdvisorApiUrl}/confirm`);

  const discard = () =>
    apiClientInstance(AuthEnums.AuthType.Company, { showErrors: true }).post(`${vismaAdvisorApiUrl}/discard`);

  return { getStatus, initiate, confirm, discard };
}

export default useVismaAdvisorService;
